import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { NgxMoveableModule } from "ngx-moveable";
import { SharedMiniModule } from "../../common/shared-mini.module";
import { SharedModule } from "../../common/shared.module";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FormatSecondsPipe } from "../../pipes/pipe-test";
import { SceneMoveableComponent } from "./scene-moveable/scene-moveable.component";
import { InputComponent } from "../../components/dynamics/dynamic-input/input.component";
import { ButtonComponent } from "../../components/dynamics/dynamic-button/button.component";
import { SelectComponent } from "../../components/dynamics/dynamic-select/select.component";
import { DateComponent } from "../../components/dynamics/date/date.component";
import { RadiobuttonComponent } from "../../components/dynamics/dynamic-radiobutton/radiobutton.component";
import { CheckboxComponent } from "../../components/dynamics/dynamic-checkbox/checkbox.component";
import { DynamicFieldDirective } from "../../components/dynamics/dynamic-field/dynamic-field.directive";
import { DynamicFormComponent } from "../../components/dynamics/dynamic-form/dynamic-form.component";
import { SceneEditorComponent } from "./scene-editor/scene-editor.component";
import { SceneBuilderComponent } from "./scene-builder/scene-builder.component";
import { NgxGuidelinesComponent } from "../../components/ngx-guidelines/ngx-guidelines.component";
import { RotatorComponent } from "../../components/rotator/rotator.component";
import { TablesSelectorComponent } from "../../components/tables-selector/tables-selector.component";
import { FocusableDirective } from "../../components/editable/focusable.directive";
import { InsertionDirective } from "../../directtives/insertion.directive";
import { SceneEditorRoutingModule } from "./scene-editor-routing.module";
import { SceneImporterComponent } from "./scene-importer/scene-importer.component";
import { SceneSharedContentsComponent } from "./scene-shared-contents/scene-shared-contents.component";
import { DialogSceneImporterComponent } from "./dialog-scene-importer/dialog-scene-importer.component";
import { EditorEntryComponent } from "./editor-entry/editor-entry.component";
import { CreateSceneComponent } from "./create-scene/create-scene.component";
import { SceneListComponent } from "./scene-list/scene-list.component";
import { SceneListPropsComponent } from "./scene-list-props/scene-list-props.component";
import { SceneListDetailsComponent } from "./scene-list-details/scene-list-details.component";
import { ConstraintCheckerComponent } from "../../components/constraint-checker/constraint-checker.component";
import { AnchorComponent } from "../../components/anchor/anchor.component";
import { DialogTokenTreeviewComponent } from "./dialog-token-treeview/dialog-token-treeview.component";
import { DialogGetAssetComponent } from "../../components/dialog-get-asset/dialog-get-asset.component";
import { ResourcesModule } from "../resources/resources.module";
import { LocationBasedComponent } from "./location-based/location-based.component";
import { GoogleMapsModule } from "@angular/google-maps";
import { PlaylistEditorComponent } from "./playlist-editor/playlist-editor.component";
import { PlaylistTimelineComponent } from "./playlist-timeline/playlist-timeline.component";
import { SceneCreateWizardComponent } from "./scene-create-wizard/scene-create-wizard.component";
import { NgxFlickingModule } from "@egjs/ngx-flicking";
import { SignageLibsModuleStudio, SignageLibsService } from "@signage/lib";
import { FontPreviewComponent } from "../../components/font-preview/font-preview.component";
import { SceneSchedulerComponent } from "./scene-scheduler/scene-scheduler.component";
import { BlockSchedulerComponent } from "./block-scheduler/block-scheduler.component";
import { BlockHourlybalancerComponent } from "./block-hourlybalancer/block-hourlybalancer.component";
import { PieChartModule } from "@swimlane/ngx-charts";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { YoutubeLicenseDialogComponent } from "../user/youtube-license-dialog/youtube-license-dialog.component";
import { SceneSocialTokenComponent } from "./scene-social-token/scene-social-token.component";
import { EditorBackgroundComponent } from "./editor-background/editor-background.component";
import { SceneNavComponent } from "./scene-nav/scene-nav.component";
import { TouchEditorComponent } from "./touch/touch-editor/touch-editor.component";
import { TouchItemComponent } from "./touch/touch-item/touch-item.component";
import { DialogTouchActionComponent } from "./touch/touch-action-dialog/touch-action-dialog.component";
import { TouchNavigationComponent } from "./touch/touch-navigation/touch-navigation.component";
import { TouchScenePropsComponent } from "./touch/touch-scene-props/touch-scene-props.component";
import { DialogPreviewComponent } from "../../components/dialog-preview/dialog-preview.component";
import { DialogPlayerDevicesComponent } from "../../components/dialog-player-devices/dialog-player-devices.component";
import { SettingToggleGroupComponent } from "../../components/setting-toggle-group/setting-toggle-group.component";
import { IconsComponent } from "../../components/icons/icons.component";
import { DialogSceneCardBrowserComponent } from "../../components/dialog-scene-card-browser/dialog-scene-card-browser.component";

// Scene Block Components
import {
    BlockLayoutCommonPropsComponent,
} from "./scene-blocks/block-layout-common-props/block-layout-common-props.component";
import { BlockAnimationDetailsComponent } from "./animation/block-animation-details/block-animation-details.component";
import { BlockAnimationConfigComponent } from "./animation/block-animation-config/block-animation-config.component";
import { BlockAnimationPreviewComponent } from "./animation/block-animation-preview/block-animation-preview.component";
import { BlockAnimationGroupComponent } from "./animation/block-animation-group/block-animation-group.component";
import { BlockBaseTransitionsComponent } from "./effects/block-base-transitions/block-base-transitions.component";
import { BlockEffectGroupComponent } from "./effects/block-effect-group/block-effect-group.component";
import { BlockEffectPropsComponent } from "./effects/block-effect-props/block-effect-props.component";
import { BlockLoaderComponent } from "./block-loader/block-loader.component";
import { BlockBaseComponent } from "./scene-blocks/block-base/block-base.component";
import { BlockBasePaddingComponent } from "./scene-blocks/block-base-padding/block-base-padding.component";
import { BlockRssComponent } from "./scene-blocks/block-rss/block-rss.component";
import { BlockLabelComponent } from "./scene-blocks/block-label/block-label.component";
import { BlockRichTextComponent } from "./scene-blocks/block-rich-text/block-rich-text.component";
import { BlockSceneComponent } from "./scene-blocks/block-scene/block-scene.component";
import { BlockClockComponent } from "./scene-blocks/block-clock/block-clock.component";
import { BlockImageComponent } from "./scene-blocks/block-image/block-image.component";
import { BlockVideoComponent } from "./scene-blocks/block-video/block-video.component";
import { BlockPlaylistComponent } from "./scene-blocks/block-playlist/block-playlist.component";
import { BlockJsonItemComponent } from "./scene-blocks/block-json-item/block-json-item.component";
import { BlockSendEventsComponent } from "./scene-blocks/block-send-events/block-send-events.component";
import { BlockReceiveEventsComponent } from "./scene-blocks/block-receive-events/block-receive-events.component";
import { BlockJsonComponent } from "./scene-blocks/block-json/block-json.component";
import { BlockFilterEventsComponent } from "./scene-blocks/block-filter-events/block-filter-events.component";
import { BlockEventSourceComponent } from "./scene-blocks/block-event-source/block-event-source.component";
import { BlockGenericComponent } from "./scene-blocks/block-generic/block-generic.component";
import { BlockYoutubeComponent } from "./scene-blocks/block-youtube/block-youtube.component";
import { BlockQrComponent } from "./scene-blocks/block-qr/block-qr.component";
import { BlockCountdownComponent } from "./scene-blocks/block-countdown/block-countdown.component";
import { BlockExtImageComponent } from "./scene-blocks/block-ext-image/block-ext-image.component";
import { BlockExtVideoComponent } from "./scene-blocks/block-ext-video/block-ext-video.component";
import { BlockInputComponent } from "./scene-blocks/block-input/block-input.component";
import { BlockCheckboxComponent } from "./scene-blocks/block-checkbox/block-checkbox.component";
import { BlockRadioComponent } from "./scene-blocks/block-radio/block-radio.component";
import { BlockSliderComponent } from "./scene-blocks/block-slider/block-slider.component";
import { BlockButtonComponent } from "./scene-blocks/block-button/block-button.component";
import { BlockSwitchComponent } from "./scene-blocks/block-switch/block-switch.component";
import { BlockStepperComponent } from "./scene-blocks/block-stepper/block-stepper.component";
import { BlockBrowserComponent } from "./scene-blocks/block-browser/block-browser.component";
import { BlockHtmlComponent } from "./scene-blocks/block-html/block-html.component";
import { BlockExternalComponent } from "./scene-blocks/block-external/block-external.component";
import { BlockLocationComponent } from "./scene-blocks/block-location/block-location.component";
import { BlockAdnetComponent } from "./scene-blocks/block-adnet/block-adnet.component";
import { BlockCartComponent } from "./scene-blocks/block-cart/block-cart.component";
import { BlockLabelqueueComponent } from "./scene-blocks/block-labelqueue/block-labelqueue.component";
import { BlockFormComponent } from "./scene-blocks/block-form/block-form.component";
import { BlockFasterqComponent } from "./scene-blocks/block-fasterq/block-fasterq.component";
import { BlockPodcastComponent } from "./scene-blocks/block-podcast/block-podcast.component";
import { BlockKeyboardComponent } from "./scene-blocks/block-keyboard/block-keyboard.component";
import { BlockCollectionComponent } from "./scene-blocks/block-collection/block-collection.component";
import { BlockSceneLoaderComponent } from "./scene-blocks/block-scene-loader/block-scene-loader.component";
import { BlockKnxComponent } from "./scene-blocks/block-knx/block-knx.component";
import { BlockSerialPortComponent } from "./scene-blocks/block-serial-port/block-serial-port.component";
import { BlockChatComponent } from "./scene-blocks/block-chat/block-chat.component";
import { BlockWebcamComponent } from "./scene-blocks/block-webcam/block-webcam.component";
import { BlockDataProviderComponent } from "./scene-blocks/block-data-provider/block-data-provider.component";
import { BlockScriptsComponent } from "./scene-blocks/block-scripts/block-scripts.component";
import { BlockFlickingComponent } from "./scene-blocks/block-flicking/block-flicking.component";
import { BlockPopComponent } from "./scene-blocks/block-pop/block-pop.component";
import { BlockCanvaComponent } from "./scene-blocks/block-canva/block-canva.component";
import { BlockMusicListComponent } from "./scene-blocks/block-music-list/block-music-list.component";
import { BlockMusicComponent } from "./scene-blocks/block-music/block-music.component";
import { BlockIconComponent } from "./scene-blocks/block-icon/block-icon.component";
import { BlockChartComponent } from "./scene-blocks/block-chart/block-chart.component";

const declarations = [
    InsertionDirective,
    FocusableDirective,
    SceneListDetailsComponent,
    SceneListPropsComponent,
    FontPreviewComponent,
    DialogTokenTreeviewComponent,
    EditorEntryComponent,
    SceneSchedulerComponent,
    ConstraintCheckerComponent,
    AnchorComponent,
    SceneCreateWizardComponent,
    CreateSceneComponent,
    EditorBackgroundComponent,
    InputComponent,
    ButtonComponent,
    SelectComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    RotatorComponent,
    SceneBuilderComponent,
    TablesSelectorComponent,
    SceneListComponent,
    SceneImporterComponent,
    SceneSharedContentsComponent,
    DialogSceneImporterComponent,
    EditorEntryComponent,
    SceneSocialTokenComponent,
    DialogGetAssetComponent,
    SceneMoveableComponent,
    SceneNavComponent,
    SceneEditorComponent,
    TouchEditorComponent,
    YoutubeLicenseDialogComponent,
    FormatSecondsPipe,
    DynamicFieldDirective,
    DynamicFormComponent,
    // FontSelectorComponent,
    NgxGuidelinesComponent,
    LocationBasedComponent,
    PlaylistEditorComponent,
    PlaylistTimelineComponent,
    TouchItemComponent,
    DialogTouchActionComponent,
    TouchNavigationComponent,
    TouchScenePropsComponent,
    DialogPreviewComponent,
    DialogPlayerDevicesComponent,
    SettingToggleGroupComponent,
    IconsComponent,
    DialogSceneCardBrowserComponent,

    // Declare Scene Block Components
    BlockLoaderComponent,
    BlockSchedulerComponent,
    BlockHourlybalancerComponent,
    BlockLayoutCommonPropsComponent,
    BlockBaseComponent,
    BlockBasePaddingComponent,
    BlockSceneComponent,
    BlockLabelComponent,
    BlockLabelqueueComponent,
    BlockRichTextComponent,
    BlockInputComponent,
    BlockSwitchComponent,
    BlockStepperComponent,
    BlockCheckboxComponent,
    BlockRadioComponent,
    BlockButtonComponent,
    BlockAdnetComponent,
    BlockSliderComponent,
    BlockFormComponent,
    BlockBrowserComponent,
    BlockCartComponent,
    BlockHtmlComponent,
    BlockExternalComponent,
    BlockFasterqComponent,
    BlockKeyboardComponent,
    BlockJsonItemComponent,
    BlockCountdownComponent,
    BlockClockComponent,
    BlockMusicListComponent,
    BlockLocationComponent,
    BlockPlaylistComponent,
    BlockFlickingComponent,
    BlockCollectionComponent,
    BlockSceneLoaderComponent,
    BlockRssComponent,
    BlockPodcastComponent,
    BlockYoutubeComponent,
    BlockQrComponent,
    BlockGenericComponent,
    BlockImageComponent,
    BlockMusicComponent,
    BlockExtImageComponent,
    BlockExtVideoComponent,
    BlockVideoComponent,
    BlockKnxComponent,
    BlockSerialPortComponent,
    BlockChatComponent,
    BlockWebcamComponent,
    BlockDataProviderComponent,
    BlockScriptsComponent,
    BlockCanvaComponent,
    BlockEventSourceComponent,
    BlockSendEventsComponent,
    BlockReceiveEventsComponent,
    BlockJsonComponent,
    BlockFilterEventsComponent,
    BlockPopComponent,
    BlockAnimationDetailsComponent,
    BlockAnimationConfigComponent,
    BlockAnimationPreviewComponent,
    BlockAnimationGroupComponent,
    BlockEffectGroupComponent,
    BlockEffectPropsComponent,
    BlockBaseTransitionsComponent,
    BlockIconComponent,
    BlockChartComponent,
];

@NgModule({
    imports: [
        SharedModule,
        DragDropModule,
        SceneEditorRoutingModule,
        ResourcesModule,
        GoogleMapsModule,
        NgxMoveableModule,
        SharedMiniModule,
        NgxFlickingModule,
        SignageLibsModuleStudio,
        PieChartModule,
        InfiniteScrollModule
    ],
    declarations,
    providers: [
        SignageLibsService,
    ],
    exports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EditorModule {
}

